import { Box, Row } from '@factorialco/deprecated-design-system'
import {
  ApprovalsConfigurationDocument,
  ApprovalsConfigurationQuery,
  ApprovalsConfigurationQueryVariables
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ApprovalsConfigurationBlockProps } from './ApprovalsConfigurationBlockProps'
import ApprovalDescription from './_ApprovalGroupDescription'
import ApprovalGroups from './_ApprovalGroups'

// Global section to be introduced within domains
const ApprovalsConfigurationBlock = ({
  category,
  title,
  description,
  multigroup = true,
  hideAddGroupButton = false,
  helpCenterUrlName,
  icon = 'calendar',
  onAddGroup,
  addGroupButtonFallback,
  noPadding = false
}: ApprovalsConfigurationBlockProps) => {
  const paddingY = noPadding ? 's0' : 's32'
  const paddingX = noPadding ? 's0' : 's64'

  const { data, loading } = useQuery<
    ApprovalsConfigurationQuery,
    ApprovalsConfigurationQueryVariables
  >(ApprovalsConfigurationDocument, {
    variables: { category }
  })

  const { approvals } = data ?? {}
  const { approvalGroupsCreate, approvalGroupsDelete, approvalGroupsEdit } =
    approvals?._policies ?? {}
  const canCreate = !!approvalGroupsCreate?.can
  const canDelete = !!approvalGroupsDelete?.can
  const canEdit = !!approvalGroupsEdit?.can
  const approvalGroups = approvals?.approvalGroups ?? []

  return (
    <Box flexGrow paddingX={paddingX} paddingY={paddingY} width="full">
      <Row>
        <Row.Col halfWidth>
          <ApprovalDescription
            category={category}
            title={title}
            description={description}
            multigroup={multigroup}
            hideAddGroupButton={hideAddGroupButton}
            helpCenterUrlName={helpCenterUrlName}
            icon={icon}
            onAddGroup={onAddGroup}
            addGroupButtonFallback={addGroupButtonFallback}
            canCreateGroup={canCreate}
          />
        </Row.Col>
        <Row.Col halfWidth>
          <ApprovalGroups
            approvalGroups={approvalGroups}
            loading={loading}
            canEdit={canEdit}
            canDelete={canDelete}
          />
        </Row.Col>
      </Row>
    </Box>
  )
}

export default ApprovalsConfigurationBlock
